import { clearStorage } from 'infra/services/auth'
import { allowedRoute } from 'presentation/utils/helpers/helpers'
import { makeAuth } from './auth'

export const guardsRoutes = async (to, from, next) => {
  try {
    await makeAuth()

    const params = new URLSearchParams(from.location.search)
    if (params.has('redirect')) {
      const redirect = params.get('redirect')
      next.redirect(atob(redirect))
    }

    if (!allowedRoute()) {
      if (window.location.pathname.includes('/bezerra')) {
        next.redirect('/home-bezerra')
      }
      next.redirect('/')
    }
    next()
  } catch (error) {
    clearStorage()
    window.location.href = `${process.env.REACT_APP_SIGNIN_URL}/logout`
    console.error('Erro ao verificar Rota.', error)
  }
}
